/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { cva } from "@panda/css";

export const downloadCard = cva({
	base: {
		flexGrow: 1,
		"& .heading": {
			lineHeight: "25px",
			letterSpacing: "0.4px",
			color: "eds.text.primary",
		},
		"& .cosmos-rich-text.paragraph": {
			lineHeight: "eds.lineHeight.150",
			color: "eds.text.secondary",

			"& a": {
				color: "eds.fill.primary.default",
				textDecoration: "underline",
				transition: `color token(animations.eds.duration.200) token(animations.eds.easing.easeInOutQuad)`,
				_hover: {
					color: "eds.fill.primary.hover",
				},
			},
		},
		"& .mobile-disclaimer": {
			borderInlineStartWidth: "2px",
			borderInlineStartStyle: "solid",
			borderInlineStartColor: "eds.fill.primary.default",
			paddingLeft: "eds.dimension.16",
			"& p": {
				color: "eds.text.primary",
			},
		},
	},
});
